import {
  useRecordContext,
  Edit,
  SaveButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  Toolbar,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  FunctionField,
  Button,
  useNotify,
  TopToolbar,
  ShowButton,
  BooleanInput,
} from 'react-admin'
import { shopifyProviderPortalTag } from '../../env'
import { formatPhoneDisplay } from '../../utils/phone'
import OutboxIcon from '@mui/icons-material/Outbox';
import { client } from '../../providers/data/client'

const ProviderAccessEditToolbar = (props) => {
  const notify = useNotify()
  const record = useRecordContext()
  return (
    <Toolbar {...props}>
      <SaveButton label="Save" />

      {record.state === 'invited' && (
        <Button
          variant="contained"
          size="medium"
          sx={{ marginLeft: 2 }}
          color="primary"
          label="Send Activation Email"
          onClick={async () => {
            try {
              const result = await client().post(`/provider-access/send-activation/${record.id}/`, {})
              if (result) notify('Activation email sent')
            } catch (error) {
              let errorMessage = 'Failed to send activation email.'

              if (error.response.data.message) {
                errorMessage = error.response.data.message
              } else if (error.response.data.error) {
                errorMessage = error.response.data.error
              } else if (error.message) {
                errorMessage = error.message
              }

              notify(errorMessage, { type: 'error', multiLine: true })
            }
          }}
        />
      )}
    </Toolbar>
  )
}

const ProviderAccessTitle = () => {
  const record = useRecordContext()
  // the record can be empty while loading
  if (!record) return null
  return <span>Provider: {record.name ?? record.email}</span>
}

export const ProviderAccessEdit = () => {
  return (
    <Edit
      actions={
        <TopToolbar>
          <ShowButton resource="provider-access" />
        </TopToolbar>
      }
      title={<ProviderAccessTitle />}
      redirect={(resource, id, data) => `provider-access/${id}/show`}
      resource="provider-access/users"
      mutationMode="pessimistic"
    >
      <SimpleForm className="form-layout" toolbar={<ProviderAccessEditToolbar />}>
        <SimpleShowLayout style={{ paddingLeft: 0 }} spacing={2} className="details-page-layout">
          <TextField label="Id" source="id" />
          <FunctionField label="Name" render={(record) => record.first_name + ' ' + record.last_name ?? 'Not Added Yet'} />
          <FunctionField label="Phone" render={(record) => formatPhoneDisplay(record.phone ?? record.default_address?.phone) || 'Not Added Yet'} />
          <TextField label="Email" source="email" />
          <TextField label="Email Verified" source="verified_email" emptyText="Not Added Yet" />
          <TextField label="State" source="state" emptyText="N/A" />
          {/* <TextField label="Clinic" source="custom:clinic_name" emptyText="Not Added Yet" /> */}
          <FunctionField
            label="Access to Provider Portal"
            render={(record) => (record.tags.includes(shopifyProviderPortalTag) ? 'Yes' : 'No')}
          />
        </SimpleShowLayout>
        <ReferenceArrayInput source="providerGroupIds" reference="provider-groups">
          <AutocompleteArrayInput fullWidth optionText={'name'} label="Provider Groups" />
        </ReferenceArrayInput>
        <ReferenceArrayInput source="providerIds" reference="providers">
          <AutocompleteArrayInput fullWidth optionText={'displayName'} label="Providers (Individual)" optionValue="providerId" />
        </ReferenceArrayInput>
        <BooleanInput
          source="kitRequests"
          label={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <OutboxIcon fontSize="small" />
              Kit Requests Enabled
            </span>
          }
          helperText="Kit Requests give the Provider-Access user the ability to create kit requests to be fulfilled 12 weeks after vasectomy. This should only be enabled for users that have an agreement with MFH for this service."
        />
      </SimpleForm>
    </Edit>
  )
}
